import { db } from "@/firebase";

const EVENT_REF = "event/0";

/**
 * Normaliza el nodo event/0 al shape que espera la app.
 * Un evento detenido (state != 1) se representa como {}, igual que cuando
 * /api/culto/vivo no devuelve ningún culto en vivo.
 */
function normalize(value) {
  if (!value || Number(value.state) !== 1) {
    return {};
  }
  return value;
}

export default {
  getActive() {
    return db
      .ref(EVENT_REF)
      .once("value")
      .then((snapshot) => normalize(snapshot.val()));
  },
  start(payload) {
    const now = new Date().toISOString();
    // event/0 es un nodo único reutilizado en cada transmisión. Se escribe un
    // id nuevo para que los mensajes del chat (filtrados por event_id) no
    // arrastren el historial del evento anterior, igual que cuando el legacy
    // creaba una fila nueva en cultos.
    return db.ref(EVENT_REF).update({
      id: Date.now(),
      link: payload.link,
      title: payload.title,
      state: 1,
      chat: 1,
      type: payload.type,
      event_group_id: payload.event_group_id,
      user_id: payload.user_id,
      created_at: now,
      updated_at: now,
    });
  },
  update(payload) {
    return db.ref(EVENT_REF).update({
      link: payload.link,
      title: payload.title,
      type: payload.type,
      event_group_id: payload.event_group_id,
      updated_at: new Date().toISOString(),
    });
  },
  patch(payload) {
    return db.ref(EVENT_REF).update({
      ...payload,
      updated_at: new Date().toISOString(),
    });
  },
  stop() {
    return db.ref(EVENT_REF).update({
      state: 0,
      updated_at: new Date().toISOString(),
    });
  },
};
